import { render, staticRenderFns } from "./scopecitycost-add-or-update.vue?vue&type=template&id=67415cbc&scoped=true&"
import script from "./scopecitycost-add-or-update.vue?vue&type=script&lang=js&"
export * from "./scopecitycost-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./scopecitycost-add-or-update.vue?vue&type=style&index=0&id=67415cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67415cbc",
  null
  
)

export default component.exports